import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { Box, Typography } from '@mui/material';
import { commonService } from '../../services';
import { date } from 'yup';
import ContentLoader from '../../components/ContentLoader';
import moment from 'moment';

export default function EsquebraDetailModal({ esquebraId, open, handleClose }) {
    const [data, setData] = React.useState({});
    const [isLoading, setIsLoading] = React.useState(true)
    React.useState(() => {
        /*
        if(Number(esquebraId)>0){
            commonService.esquebrasById(esquebraId).then((data) => {
                setData(data)
                setIsLoading(false)
            }).catch(() => {
                setIsLoading(false)
            })
        }*/
        commonService.esquebrasById(esquebraId).then((data) => {
            setData(data)
            setIsLoading(false)
        }).catch(() => {
            setIsLoading(false)
        })
       
    }, [esquebraId])
    return (
        <div>
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                sx={{
                    borderTopLeftRadius: 4,
                    borderBottomLeftRadius: 4,
                    borderTopRightRadius: 4,
                    borderBottomRightRadius: 4,
                }}

                maxWidth={'sm'}
                fullWidth={true}
            >
                {!isLoading ?
                    <Box>
                        <Box bgcolor={'#ececec'}>
                            <img width={'100%'} src={data.image} />
                            <Box display={'flex'} justifyContent={'center'} alignItems={'center'} gap={4}>
                                <Box display={'flex'} flexDirection={'row'} gap={1}>
                                    <Typography textTransform={'uppercase'}>Inicio</Typography>
                                    <Typography fontWeight={900}>{data.online_from}</Typography>
                                </Box>
                                <Box display={'flex'} flexDirection={'row'} gap={1} >
                                    <Typography textTransform={'uppercase'}>FIM</Typography>
                                    <Typography fontWeight={900}>{data.online_to}</Typography>

                                </Box>
                            </Box>

                        </Box>
                        <Box>
                            <Typography mb={4} mt={4} align='center' variant='h1'>{data.title}</Typography>
                            <Typography align='center' sx={{ overflowWrap: 'break-word' }}>
                              
                            </Typography>

                        </Box>

                        <Box bgcolor={'#cfcfcf'} p={1} >
                            <Typography mt={4} align='center' variant='h5'>Condições de Utilização</Typography>
                            <Typography align='center' sx={{ overflowWrap: 'break-word' }}>
                                {data.condition_text}
                            </Typography>

                        </Box>

                    </Box>

                    : null}

            </Dialog>
            <ContentLoader open={isLoading} />

        </div>
    );
}